<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img src="/static/img/blue_2@3x.png"/>
              <div class="media-body">
                <h1>{{classInfo.class_name}}</h1>
                <div><span class="gray">과목</span> {{classInfo.cate_code_name}}  ·  <span class="gray">클래스 인원 </span> <span class="number">{{classUserData.length}}</span>  · <span class="gray">담당선생님</span> {{classInfo.class_manager_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body el-tabs__content">
        <div class="d-flex">
          <div class="p-2">
            <!-- <h2>성적분포</h2> -->
          </div>
        </div>

        <el-row :gutter="40">
          <el-col :span="14">
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                 <h2>시험 <span class="number mint">{{classExamTableData.length}}</span></h2>
                </div>
              </div>
              <!-- 그리드 -->
              <stone-data-table
                table-ref="classExamTable"
                :columns="classExamTableColumns"
                :data="classExamTableData"
                :table-props="classExamTableProps"
                :current-row="currentRow"
                :loading="examSearchLoading"
                @row-click="classExamRowClickHandler">
              </stone-data-table>
            </fieldset>
          </el-col>
          <el-col :span="10">
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                 <h2>시험 응시 인원 <span class="number mint">{{classUserData.length}}</span></h2>
                </div>
              </div>
              <!-- 그리드 -->
              <stone-data-table
                :loading="classSearchLoading"
                :columns="classUserColumns"
                :data="classUserData"
                :table-props="classUserTableProps"
                :page-size="emptyPageSize"
                :pagination-props="emptyPaginationProps"
                @row-click="classUserRowClickHandler">
              </stone-data-table>
            </fieldset>
          </el-col>
        </el-row>

      </div>
    </div>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M060202',
  mixins: [common.mixins],
  data () {
    return {
      classInfo: {
        class_seq: 0,
        cate_code: '',
        cate_code_name: '',
        class_name: '',
        class_manager: '',
        class_manager_name: '',
        memo: '',
        use_yn: 'Y',
        class_user: []
      },
      classUserTableProps: {height: this.getScreenHeight(70), rowClassName: this.membershipRowClassName},
      classUserData: [],
      classUserColumns: [
        {label: 'No', align: 'center', type: 'index', width: 50},
        {label: '이름', prop: 'user_name', align: 'center'},
        {label: '전화번호', prop: 'phone', align: 'center', formatter: this.columnFormatterPhone},
        // {label: '학교', prop: 'school_name', align: 'left'},
        // {label: '응시여부', prop: 'exam_user_stat_name', align: 'center', width: 50}
        {label: '점수', prop: 'exam_score', align: 'center', width: 50},
        {label: '석차', prop: 'exam_rank', align: 'center', width: 50}
      ],
      classExamTableProps: {height: this.getScreenHeight(120), highlightCurrentRow: true},
      classExamTableData: [],
      classExamTableColumns: [
        {label: 'No', align: 'center', type: 'index', width: 50},
        // {label: '시험번호', prop: 'exam_seq', align: 'center', width: 70},
        {label: '시험명', prop: 'title', align: 'left', width: 220},
        {label: '유형', prop: 'exam_type_name', align: 'center', width: 70},
        // {label: '과목', prop: 'subject', align: 'center', width: 70},
        {label: '공개일자', prop: 'open_dt', align: 'center', formatter: this.columnFormatterDate, width: 80},
        {label: '종료일자', prop: 'close_dt', align: 'center', formatter: this.columnFormatterDate, width: 80}
      ],
      examSearchLoading: false,
      classSearchLoading: false,
      currentRow: null
    }
  },
  beforeCreate () {
    if (this.$route.params.class_seq === undefined || this.$route.params.class_seq === 0) {
      this.$router.push({name: 'M060201'})
    }
  },
  created () {
    const classSeq = this.$route.params.class_seq
    this.loadInfo(classSeq)
    this.retrieveExam(classSeq)
  },
  methods: {
    // 클래스 정보 조회
    loadInfo (classSeq) {
      common.axios.get('/class/info/' + classSeq)
        .then(response => {
          const result = response.data
          Object.keys(this.classInfo).forEach(key => {
            this.classInfo[key] = result[key]
          })
        })
    },
    retrieveExam (classSeq) {
      this.examSearchLoading = true
      common.axios.post('/exam/list', {stat: 'C', stat_class_seq: classSeq})
        .then(response => {
          this.examSearchLoading = false
          this.classExamTableData = response.data
        })
        .catch(() => {
          this.examSearchLoading = false
        })
    },
    retrieveExamClassUser (examSeq) {
      this.classSearchLoading = true
      // common.axios.post('/exam/class/user', {exam_seq: examSeq, class_seq: this.classInfo.class_seq})
      common.axios.post('/exam/class/user', {exam_seq: examSeq, class_seq: this.classInfo.class_seq, stat: 'S', order: 'RANK'})
        .then(response => {
          this.classSearchLoading = false
          this.classUserData = response.data
        })
        .catch(() => {
          this.classSearchLoading = false
        })
    },
    classUserRowClickHandler (row) {
      if (row.exam_user_stat === 'S') {
        this.$router.push({name: 'M060103', params: row})
      } else {
        this.$message.warning('미응시생은 성적표를 확인할 수 없습니다.')
      }
    },
    classExamRowClickHandler (row) {
      this.currentRow = row
      this.retrieveExamClassUser(row.exam_seq)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/M060202.vue